/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskCraIdResult
 */
export interface ExecRiskCraIdResult {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskCraIdResult
     */
    cra_id: string;
}

/**
 * Check if a given object implements the ExecRiskCraIdResult interface.
 */
export function instanceOfExecRiskCraIdResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cra_id" in value;

    return isInstance;
}

export function ExecRiskCraIdResultFromJSON(json: any): ExecRiskCraIdResult {
    return ExecRiskCraIdResultFromJSONTyped(json, false);
}

export function ExecRiskCraIdResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskCraIdResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cra_id': json['cra_id'],
    };
}

export function ExecRiskCraIdResultToJSON(value?: ExecRiskCraIdResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cra_id': value.cra_id,
    };
}

